import NAVIGATION from '@/constant/navigation.js';

import getDeviceInfo from '@/lib/base/getDeviceInfo';
const deviceDetails = getDeviceInfo();
const {viewMode} = deviceDetails;
const isMobile = viewMode === 'phone';

export default [
  {
    path: '/learning',
    name: 'learning',
    component: () => import('@/views/Learning/index.vue'),
    meta: {
      hasNavigation: true,
      requireAuth: true,
      depth: 1,
      activeTab: NAVIGATION.TABS.LEARNING,
    },
  },
  {
    path: '/learning/study-tasks',
    name: 'learningStudyTasks',
    component: () => import('@/views/Learning/LearningStudyTasks.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
      depth: 1,
      activeTab: NAVIGATION.TABS.LEARNING,
    },
  },
  {
    path: '/learning/my-courses',
    name: 'myCourses',
    component: () => import('@/views/StudentManagement/StudentLiveCourse.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
      depth: 1,
      activeTab: NAVIGATION.TABS.LEARNING,
    },
  },
  {
    path: '/learning/skill-tree',
    name: 'skillTree',
    component: () => import('@/views/Learning/SkillTree.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
      depth: 1,
      activeTab: NAVIGATION.TABS.LEARNING,
    },
  },
  {
    path: '/learning/redeem',
    name: 'redeem',
    component: () => import('@/views/Redeem/Redeem.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
      depth: 1,
      activeTab: NAVIGATION.TABS.LEARNING,
    },
  },
  {
    path: '/learning/redeem/:liveCourseId',
    name: 'redeemLiveCourse',
    component: () => import('@/views/Redeem/RedeemLiveCourse.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
      depth: 1,
      activeTab: NAVIGATION.TABS.LEARNING,
    },
  },
  {
    path: '/learning/redeem/:liveCourseId/:liveCourseUnitId',
    name: 'redeemLiveCourseUnit',
    component: () => import('@/views/Redeem/RedeemLiveCourseUnit.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
      depth: 1,
      activeTab: NAVIGATION.TABS.LEARNING,
    },
  },
  {
    path: '/learning/:mode',
    name: 'learningPage',
    component: () => import('@/views/LearnPage.vue'),
    meta: {
      hasNavigation: true,
      requireAuth: true,
      activeTab: NAVIGATION.TABS.LEARNING,
    },
  },
];
